var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBedroomsicon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6v1.05A2.5 2.5 0 002 9.5v4a.5.5 0 001 0V13h12v.5a.5.5 0 001 0v-4a2.5 2.5 0 00-2-2.45V6a2 2 0 00-2-2H6a2 2 0 00-2 2zm8-1H6a1 1 0 00-1 1v1h8V6a1 1 0 00-1-1zm3 7V9.5A1.5 1.5 0 0013.5 8h-9A1.5 1.5 0 003 9.5V12h12z"
  })));
});
export default SvgBedroomsicon;